'use strict';

exports.__esModule = true;
exports.calculateSizeCover = undefined;
exports.calculateSizeCoverBase = calculateSizeCoverBase;

var _dom = require('./dom');

var _utils = require('./utils');

/**
 * Returns filled { width, height } of an image that is best for current device based on given params.
 * @param oW - original image width
 * @param oH - original image height
 * @param w - new image width (the size that image will be shown)
 * @param h - new image height (the size that image will be shown)
 * @param sW - screenWidth, injected for testing, on live taken from window
 * @param pR - pixelRatio, injected for testing, on live taken from window
 * @returns { width, height }
 */
function calculateSizeCoverBase(_ref) {
  var oW = _ref.oW,
      oH = _ref.oH,
      w = _ref.w,
      h = _ref.h,
      pR = _ref.pR;

  if (w >= oW || h >= oH || !(w || h)) {
    return {
      width: oW,
      height: oH
    };
  } else if (w && h) {
    var propW = (0, _utils.getProportionalWidth)(oW, oH, h);
    var propH = (0, _utils.getProportionalHeight)(oW, oH, w);
    var scaleByW = propH >= h;
    return (0, _utils.adjustSizeByPixelRatio)(oW, oH, scaleByW ? w : propW, scaleByW ? propH : h, pR);
  } else if (w) {
    return (0, _utils.adjustSizeByPixelRatio)(oW, oH, w, (0, _utils.getProportionalHeight)(oW, oH, w), pR);
  } else if (h) {
    return (0, _utils.adjustSizeByPixelRatio)(oW, oH, (0, _utils.getProportionalWidth)(oW, oH, h), h, pR);
  }
}

var calculateSizeCover = exports.calculateSizeCover = (0, _dom.decorateWithDomParams)((0, _utils.snapWidthToScreenWidthIfSmallScreen)(calculateSizeCoverBase));